// eslint-disable-next-line no-shadow
export enum DataValueType {
    Relative = "relative",
    Absolute = "absolute"
}
